document.addEventListener('DOMContentLoaded', function () {
    // Select all accordion headers
    const accordionHeaders = document.querySelectorAll('.accordion-item-header');

    // Add event listeners for each header
    accordionHeaders.forEach(header => {
        const content = header.nextElementSibling;
        const icon = header.querySelector('span img, span svg');

        // Open default items
        if (content.classList.contains('is-default-open')) {
            // Remove the default open class
            content.classList.remove('is-default-open');
            content.classList.add('is-open');
            content.classList.remove('is-closed');

            // Update icon to open state
            if (icon) {
                icon.src = header.dataset.openIconUrl || ''; // Use the open icon URL
            }
        } else {
            content.classList.add('is-closed');
            content.classList.remove('is-open');

            // Update icon to close state
            if (icon) {
                icon.src = header.dataset.closeIconUrl || ''; // Use the close icon URL
            }
        }

        // Add click event listener to toggle open/close
        header.addEventListener('click', function () {
            const isOpen = content.classList.contains('is-open');

            // Close all other contents
            const allContents = document.querySelectorAll('.accordion-item-content');
            allContents.forEach(c => {
                c.classList.remove('is-open');
                c.classList.add('is-closed');
            });

            // Open the clicked content
            if (isOpen) {
                content.classList.remove('is-open');
                content.classList.add('is-closed');

                // Update icon to close state
                if (icon) {
                    icon.src = header.dataset.closeIconUrl || ''; // Use the close icon URL
                }
            } else {
                content.classList.remove('is-closed');
                content.classList.add('is-open');

                // Update icon to open state
                if (icon) {
                    icon.src = header.dataset.openIconUrl || ''; // Use the open icon URL
                }
            }
        });
    });
});
